import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import { APPLICATION_CONTEXTS } from '../../constants';
import PatientBanner from '../common/patientBanner';
import NavigationBar from '../common/navigationBar';

class MealSummary extends Component {
  /**************
   * Properties *
   **************/
  PAGE_DOWN = 1;
  PAGE_UP = -1;
  state = {
    bannerVisible: {
      visible: true
    },
    baseUrl: '/room_service/summary',
    direction: this.PAGE_DOWN,
    navigationBar: {
      mainMenu: true,
      back: true,
      backRoute: '/room_service'
    },
    meals: {
      lunch: [require('./images/RoomService_Lunch_Summary_1.png'), require('./images/RoomService_Lunch_Summary_2.png')]
    }
  };

  getCurrentMeal = () => this.props.match.params.meal;

  getCurrentPage = () => parseInt(this.props.match.params.page, 10);

  getCurrentPageSrc = () => {
    const meal = this.getCurrentMeal();
    const numPages = this.getCurrentMealNumPages();
    let page = this.getCurrentPage();
    if (page <= 0) {
      page = 1;
    }
    if (page > numPages) {
      page = numPages;
    }
    if (this.state.meals[meal]) {
      return this.state.meals[meal][page - 1];
    }
    return null;
  };

  getNextPage = () => {
    const numPages = this.getCurrentMealNumPages();
    let page = this.getCurrentPage();
    page++;
    if (page > numPages) {
      page = numPages;
    }
    this.setDirection(page);
    return page;
  };

  getPreviousPage = () => {
    let page = this.getCurrentPage();
    page--;
    if (page <= 0) {
      page = 1;
    }
    this.setDirection(page);
    return page;
  };

  getCurrentMealNumPages = () => {
    const meal = this.getCurrentMeal();
    if (this.state.meals[meal]) {
      return this.state.meals[meal].length;
    }
    return 0;
  };

  setDirection = page => {
    if (page === 1) {
      this.setState({
        direction: this.PAGE_DOWN
      });
    } else if (page === this.getCurrentMealNumPages()) {
      this.setState({
        direction: this.PAGE_UP
      });
    }
  };

  handleGetNextPage = () =>
    this.props.history.push(`${this.state.baseUrl}/${this.getCurrentMeal()}/${this.getNextPage()}`);

  handleGetPreviousPage = () =>
    this.props.history.push(`${this.state.baseUrl}/${this.getCurrentMeal()}/${this.getPreviousPage()}`);

  handleSelect = () => {
    switch (this.state.direction) {
      case this.PAGE_DOWN:
        this.handleGetNextPage();
        break;
      case this.PAGE_UP:
        this.handleGetPreviousPage();
        break;
      default:
        console.info(`MealSummary::handleSelect() - Unhandled direction: ${this.state.direction}`);
    }
  };

  handleOnKeyUp = event => {
    if (this.props.context !== APPLICATION_CONTEXTS.SERVICES) {
      return;
    }
    switch (event.key) {
      case 'ArrowDown':
        this.handleGetNextPage();
        break;
      case 'ArrowUp':
        this.handleGetPreviousPage();
        break;
      case 'Enter':
        this.handleSelect();
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will add a listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    const page = this.getCurrentPageSrc();
    if (page === null) {
      this.props.history.push('/room_service');
      return null;
    }
    return (
      <div className="service-1277">
        <PatientBanner {...this.state.bannerVisible} />
        <img className="summary-page" src={page} alt="" />
        <button className="page-up" onMouseUp={this.handleGetPreviousPage} />
        <button className="page-down" onMouseUp={this.handleGetNextPage} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedMealSummary = connect(
  state => ({
    context: state.application.currentContext
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        ...applicationActions
      },
      dispatch
    )
  })
)(MealSummary);

export default withRouter(ConnectedMealSummary);
